import React from "react"

import { useSelector } from "react-redux"
import QRcode from "./QRcode"
import QRcodeWelcomeMessageEN from "./QRcodeWelcomeMessageEN"

const PatientEN = () => {

    const listItems = useSelector(store => store.reply.patientData)

    return (
        <>  
            <h1 className="title">Summary: Questionnaire data</h1>
            <QRcodeWelcomeMessageEN />
            <QRcode />
            
            {listItems.map((item) => (
            <div className="patients" key={item._id}>

                <div> <span className="time-info">submitted: </span>{String(item.createdAt).split('T')[0]}</div>
                <h2 className="subtitle">Basic questions</h2>

                <div className="time"> {item.createdAt}</div>



                <div><span className="basic-info">username: </span> 
                    {item.username}
                </div>

                <div><span className="basic-info">age: </span>
                    {item.age}
                </div>

                <div><span className="basic-info">gender: </span> 
                    {item.gender}
                </div>

                <div><span className="basic-info">diabetes: </span> 
                    {item.diabetesType}
                </div>

                <div><span className="basic-info">In what region do you live? </span> 
                    {item.q1}
                </div>

                <div><span className="basic-info">Which year you was diagnosed with diabetes? </span> 
                    {item.diagnosisYear}
                </div>

                <div><span className="basic-questions">How do you currently manage your condition? 
                    e.g., insulin, other medications, dietary supplements, 
                    diet, exercise? Please describe: </span>
                    <div className="answers">
                        {item.q2}
                    </div> 
                </div>

                <div><span className="basic-questions">How often do you check your blood sugar levels?</span>
                    <div className="answers">
                        {item.q3}
                    </div>
                </div>

                <div><span className="basic-questions">What is the most challenging aspect about having diabetes?</span>
                    <div className="answers">
                        {item.q4}
                    </div>
                </div>

                <div><span className="basic-questions">Have you ever received professional help to guide you in your diet?
                    Please tell us about your experience with dieting:</span>
                    <div className="answers">
                        {item.q5}
                    </div>
                </div>

                <div><span className="basic-questions">What do you think is the most challenging aspect about following a 
                    diet to manage diabetes?:</span>
                    <div className="answers">
                        {item.q6}
                    </div>
                </div>

                <div><span className="basic-questions">Have you experienced any diabetes-related issues in the workplace?</span>
                    <div className="answers">
                        {item.q7}
                    </div>
                </div>

                <div><span className="basic-questions">Does the place you work/ used to work provided you 
                    with any diabetes- related support? If yes, please describe</span>
                    <div className="answers">
                        {item.q8}
                    </div>
                </div>
                
                <div><span className="basic-questions">How comfortable are you with using technology and mobile phone apps? Have you ever 
                            used a digital app to help you with diabetes management? 
                            If yes, please tell us which app did you use or using and what was your experience:</span>
                    <div className="answers">
                        {item.q9}
                    </div>
                </div>

                <h2 className="subtitle">GlucoNutris app questions</h2>
                
                <div><span className="basic-questions">What kind of features would you want an app for 
                    diabetes patients to have?</span>
                    <div className="answers">
                        {item.qA1}
                    </div>
                </div>

                <div><span className="basic-questions">What is the most important aspect of dietary management 
                    for diabetes that you would like an app to assist you with?</span>
                    <div className="answers">
                        {item.qA2}
                    </div>
                </div>

                <div><span className="basic-questions">How would you feel about having interactive methods, 
                    such as quizzes or trivias, as a way to learn about diabetes?</span>
                    <div className="answers">
                        {item.qA3}
                    </div>
                </div>

                <h4 className="sub-subtitle">
                    Please, rate how useful do you find the following features for a mobile app that helps you 
                    to manage your diet (1- useless, 5- excellent): 
                </h4>

                <div><span className="basic-questions">Acquiring knowledge about diabetes through interactive methods. 
                            Please rate on the scale from useless(1) to excellent(5)</span>
                    <div className="answers">
                        {item.qA4r}
                    </div>
                </div>

                <div><span className="basic-questions">Getting a nutritional evaluation and your dietary requirements calculated. 
                            Please rate on the scale from useless(1) to excellent(5)</span>
                    <div className="answers">
                        {item.qA5r}
                    </div>
                </div>

                <div><span className="basic-questions">Getting your personalized meal plan. 
                            Please rate on the scale from useless(1) to excellent(5)</span>
                    <div className="answers">
                        {item.qA6r}
                    </div>
                </div>

                <div><span className="basic-questions">Registering your meals. 
                            Please rate on the scale from useless(1) to excellent(5)</span>
                    <div className="answers">
                        {item.qA7r}
                    </div>
                </div>

                <div><span className="basic-questions">Keeping track of your physical activity. 
                            Please rate on the scale from useless(1) to excellent(5)</span>
                    <div className="answers">
                        {item.qA8r}
                    </div>
                </div>

                <div><span className="basic-questions">Having online consultations with dieticians. 
                            Please rate on the scale from useless(1) to excellent(5)</span>
                    <div className="answers">
                        {item.qA9r}
                    </div>
                </div>

                <div><span className="basic-questions">Receiving a personalized grocery shopping list for a weakly choice 
                            of your meals. Please rate on the scale from useless(1) to excellent(5)</span>
                    <div className="answers">
                        {item.qA10r}
                    </div>
                </div>

                <div><span className="basic-questions">Getting a weakly menu suggestions with recipes.
                            Please rate on the scale from useless(1) to excellent(5)</span>
                    <div className="answers">
                        {item.qA11r}
                    </div>
                </div>

                <div><span className="basic-questions">Access to a pool of recipes.
                            Please rate on the scale from useless(1) to excellent(5)</span>
                    <div className="answers">
                        {item.qA12r}
                    </div>
                </div>

                <div><span className="basic-questions">Keeping track of your blood sugar measurements. 
                            Please rate on the scale from useless(1) to excellent(5)</span>
                    <div className="answers">
                        {item.qA13r}
                    </div>
                </div>

                <div><span className="basic-questions">Tracking your pulse and blood pressure.  
                            Please rate on the scale from useless(1) to excellent(5)</span>
                    <div className="answers">
                        {item.qA14r}
                    </div>
                </div>

                <div><span className="basic-questions">Do you want an app which gives you options for different diets 
                            (e.g. Mediterranean, keto, whole food, gluten- free, vegetarian) or one that tailors a meal 
                            plan based on your personal preferences?</span>
                    <div className="answers">
                        {item.qA15}
                    </div>
                </div>

                <h4 className="sub-subtitle">
                    We also would like to ask your opinion about the following: 
                </h4>

                <div><span className="basic-questions">Would you like the option to easily find and select meals with a 
                            minimal number of ingredients or shortest cooking time?</span>
                    <div className="answers">
                        {item.qA16}
                    </div>
                </div>

                <div><span className="basic-questions">Would you like the option to join a community within the app 
                            where you can talk to other people who have diabetes and get help from healthcare 
                            experts?</span>
                    <div className="answers">
                        {item.qA17}
                    </div>
                </div>

                <div><span className="basic-questions">Do you think it would be helpful to have a rewards program for staying on 
                            track with your diet plan? Such as receiving gifts, discounts on workout equipment 
                            or additional consultations with dieticians or may be you have your own suggestions?</span>
                    <div className="answers">
                        {item.qA18}
                    </div>
                </div>

                <div><span className="basic-questions">Would it be beneficial for you to have the option to schedule regular 
                            check-ins with a dietician through the app</span>
                    <div className="answers">
                        {item.qA19}
                    </div>
                </div>

                <div><span className="basic-questions">What kind of help from a digital health app that assists you in managing 
                            diabetes through diet, would make you more likely to stick to lifestyle changes?
                            Please elaborate.</span>
                    <div className="answers">
                        {item.qA20}
                    </div>
                </div>

                <div><span className="basic-questions">Could you tell us if you would enjoy a feature that allows users to 
                            create and share their own dish recipes? With the added benefit of the recipes being reviewed 
                            by a dietician before they are published? And also, how do you think this feature would help 
                            keep users engaged with the application?</span>
                    <div className="answers">
                        {item.qA21}
                    </div>
                </div>

                <div><span className="basic-questions">Which specific features of the app would you consider worth paying for?</span>
                    <div className="answers">
                        {item.qA22}
                    </div>
                </div>

                <div><span className="basic-questions">Is there anything else you would like to share?</span>
                    <div className="answers">
                        {item.qA23}
                    </div>
                </div>

            </div>
            ))}
            <h2 className="patient-placeholder">PLACEHOLDER</h2>
        </>
    )
}

export default PatientEN